import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Table, TableBody, TableContainer, TableHead, TableRow, Paper, Container, IconButton,
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Download, Link as LinkIcon } from "@mui/icons-material";

import { useState, useEffect } from "react";

import Config from "../config.json";
import { dateToStringDate } from "../Helpers";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function Qcqa() {
  const url_list = Config.api_domain + "/qcqa/active/";
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [open, setOpen] = useState(true); // Modal langsung terbuka

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(url_list, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");

        const data = await res.json();
        setList(data.data || []);
      } catch (error) {
        console.error("Fetch error:", error.message);
      }
    };

    fetchData();
  }, [url_list]);

  const filteredList = list.filter(item =>
    item.title.toLowerCase().includes(search.toLowerCase())
  );

  const paginatedList = filteredList.slice(
    page * entriesPerPage,
    (page + 1) * entriesPerPage
  );

  function getRows() {
    if (typeof list !== "undefined" && list !== null && list.length > 0) {
      return list.map((row, index) => {
        let dateISO = new Date(row.time_uploaded);
        let formatted_datetime = dateToStringDate(dateISO);
        return (
          <StyledTableRow key={row.public_id}>
            <StyledTableCell>{index + 1}</StyledTableCell>
            <StyledTableCell>{row.title}</StyledTableCell>
            <StyledTableCell>{formatted_datetime}</StyledTableCell>
            <StyledTableCell>
              <IconButton
                aria-label="download"
                component="a"
                href={Config.api_domain + "/qcqa/download/" + row.public_id}
                download
              >
                <Download />
              </IconButton>
            </StyledTableCell>
          </StyledTableRow>
        );
      });
    } else {
      return (
        <StyledTableRow key="no-data">
          <StyledTableCell colSpan={4} align="center">
            No Data Found
          </StyledTableCell>
        </StyledTableRow>
      );
    }
  }

  return (
    <div style={{ padding: "1em 2em 3em 2em" }}>
      <Container>

        {/* === POPUP / MODAL === */}
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Important Notice</DialogTitle>
          <DialogContent dividers>
            <Typography paragraph>
              Dear All,
            </Typography>
            <Typography paragraph>
              The work package has not started yet. Project activities and progress updates will be provided once implementation begins.
            </Typography>
            <Typography paragraph>
              All necessary information regarding procurement preparation, including submission deadlines 
              and related details, will be made available on our procurement website at the earliest opportunity.
            </Typography>
            <Typography paragraph>
              Kindly refer to our website for the updates:{" "}
              <a href="https://ilaspp-proc.big.go.id/" target="_blank" rel="noreferrer">
                https://ilaspp-proc.big.go.id/
              </a>.
            </Typography>
            <Typography paragraph>
              Thank you.
            </Typography>
            <Typography>
              Regards,<br/>
              Procurement Working Group,<br/>
              Geospatial Information Agency
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpen(false)} variant="contained">
              OK
            </Button>
          </DialogActions>
        </Dialog>

        {/* === KONTEN ASLI === */}
        <h2>QC/QA Base Maps</h2>

        <h3>Project Description</h3>
        <p style={{ textAlign: "justify" }}>
          As part of the implementation of the Integrated Land Administration and Spatial Planning (ILASP) Project, the Geospatial Information Agency (BIG) is seeking a consulting firm (or consortium) to provide quality assurance and quality control (QA/QC) services. The objective is to ensure the accuracy, consistency, and timely delivery of geospatial data and Base Maps. This assignment, scheduled for the period 2026–2029, will involve verifying the outputs of 3D geospatial data production in both urban and non-urban areas, as well as the Base Maps Production and Generalization of digital maps across various scales (from 1:5,000 up to 1:1,000,000). The selected consultant will act on behalf of BIG, work in close coordination with the Directorate of Land Topographic Mapping, and submit reports and documentation that will serve as the basis for project-related payment processes.
        </p>

        {/* Unduh Section */}
        <h3>Announcement</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getRows()}
            </TableBody>
          </Table>
        </TableContainer>

        <h3>Procurement Timeline</h3>
        <TableContainer component={Paper} sx={{ mb: 6 }}>
          <Table sx={{ minWidth: 500 }} aria-label="timeline table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No.</StyledTableCell>
                <StyledTableCell>Activity</StyledTableCell>
                <StyledTableCell>Start Date</StyledTableCell>
                <StyledTableCell>End Date</StyledTableCell>
                <StyledTableCell>Link</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <StyledTableRow>
                <StyledTableCell>1</StyledTableCell>
                <StyledTableCell>Pre-bid Meeting</StyledTableCell>
                <StyledTableCell>Not Started Yet</StyledTableCell>
                <StyledTableCell>Not Started Yet</StyledTableCell>
                <StyledTableCell>
                  <IconButton
                    component="a"
                    href="#"
                    aria-label="link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LinkIcon />
                  </IconButton>
                </StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>2</StyledTableCell>
                <StyledTableCell>Sample Data Access</StyledTableCell>
                <StyledTableCell>Not Started Yet</StyledTableCell>
                <StyledTableCell>Not Started Yet</StyledTableCell>
                <StyledTableCell>
                  <IconButton
                    component="a"
                    href="/#/"
                    aria-label="link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LinkIcon />
                  </IconButton>
                </StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
        </TableContainer>

      </Container>
    </div>
  );
}

export default Qcqa;